import { Navigate } from "react-router-dom";
// import useAuth from "../hooks/useAuth";

export default function PublicRoute({ children }) {
  // const isLoggedIn = useAuth();
  const localAuth = localStorage?.getItem("auth");

  return !localAuth ? children : <Navigate to="/brri" />;
}
